import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BuilderInfoService } from '@portal/builder';
import { MultiLangPipe } from './multilang.pipe';

@Pipe({
  name: 'sort',
  pure: true,
  standalone: false,
})
export class SortPipe implements PipeTransform {
  private readonly builderInfoService = inject(BuilderInfoService);
  private readonly translateService = inject(TranslateService);

  private readonly multiLangPipe = new MultiLangPipe(this.builderInfoService, this.translateService);
  transform<T extends P & Record<string, P>, P = object>(items: T[], field: string, alphabetically = false): T[] {
    if (!items || !field) {
      return items;
    }

    if (!alphabetically) {
      return items.sort(item => (this.multiLangPipe.transform(item[field]) ? -1 : 1));
    }

    return items.sort((a: Record<string, unknown>, b: Record<string, unknown>) => {
      const nameA = this.multiLangPipe.transform(a[field])?.toLowerCase();
      const nameB = this.multiLangPipe.transform(b[field])?.toLowerCase();

      return nameA < nameB ? -1 : 1;
    });
  }
}
